module.exports = __webpack_public_path__ + "media/images/docspin-logo-dark-cf9ed7c0ef0a4cfba9b49a43fba16e1e.png";